import clsx from 'clsx'
import { FC, useEffect, useState } from 'react'

import Loader from '../loader/loader'
import { ILectorsCircles, prepareLecturNames } from './data'
import { AVATAR_HALF_WIDTH } from './utils'
import { ILectur } from 'constants/types/common.types'
import { getLectorPreview } from 'components/cards/lector-card/utils'
import { BASE_URL } from 'constants/url'
import { getAxiosSingle } from 'pages/api/axios'

import styles from './lectors-circles.module.scss'

const LectorsCircles: FC<ILectorsCircles> = ({
  lectursIds,
  dopLecturNames = '',
  dopLecturAmmount = 0,
  borderColor,
  wrapperModificator,
  isNamesBreaked,
}: ILectorsCircles) => {
  const [lectors, setLectors] = useState<ILectur[] | null>(null)

  useEffect(() => {
    const getData = async () => {
      const allInfoLectors = lectursIds.map((id) => getAxiosSingle(`${BASE_URL.LECTUR}/${id}`))
      Promise.all(allInfoLectors).then((results) => {
        const data = results.filter((result) => {
          if (result.status) {
            console.log(`Не удалось получить Лектора в <CourseLectorsBlock/>`)
            return false
          }
          return true
        })

        setLectors(data)
      })
    }
    getData()
  }, [])

  const lecturNames = prepareLecturNames(lectors, dopLecturNames)

  if (!lectors || lectors?.length === 0) return <Loader modificator={styles.loader} />

  return (
    <div
      className={clsx(styles.wrapper, {
        [wrapperModificator as string]: wrapperModificator,
      })}
    >
      <div
        className={styles.avatarWrapper}
        style={{
          width: `${(lectors.length + (dopLecturNames ? 2 : 1)) * AVATAR_HALF_WIDTH}px`,
        }}
      >
        {/* Цифра для лекторов без аватарки, например, +2 */}
        {dopLecturNames && (
          <div
            className={styles.lecturWrapper}
            style={{
              border: `2px solid ${borderColor}`,
              left: `${AVATAR_HALF_WIDTH * lectors.length}px`,
            }}
          >
            <div className={styles.avatar}>
              <p className={styles.countLecturs}>{`+${dopLecturAmmount}`}</p>
            </div>
          </div>
        )}

        {[...lectors].reverse().map((lectur, idx) => {
          const { previewName, id } = lectur
          const leftShift = AVATAR_HALF_WIDTH * (lectors.length - 1 - idx)

          return (
            <div key={id} className={styles.lecturWrapper} style={{ left: `${leftShift}px` }}>
              {getLectorPreview('', '', previewName, styles.avatar, 'white', borderColor)}
            </div>
          )
        })}
      </div>
      {lectors?.length > 0 && (
        <div
          className={clsx(styles.author, {
            [styles.authorBreaked]: isNamesBreaked,
          })}
        >
          {lecturNames}
        </div>
      )}
    </div>
  )
}

export default LectorsCircles
